import React from 'react';

const DetailsSection: React.FC = () => {
  return (
    <section className="py-12 md:py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            Why Choose This Over Everything Else?
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            See how we stack up against the competition
          </p>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden border border-gray-200 rounded-xl shadow-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gradient-to-r from-gray-900 to-gray-800">
                  <tr>
                    <th scope="col" className="px-3 md:px-6 py-3 md:py-4 text-left text-xs md:text-sm font-bold text-white uppercase tracking-wider">
                      Feature
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-emerald-400 uppercase tracking-wider bg-emerald-950/30">
                      Our Pistol Lighter
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-white uppercase tracking-wider">
                      Cheap Disposables
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-white uppercase tracking-wider">
                      Zippo
                    </th>
                    <th scope="col" className="px-3 md:px-6 py-3 md:py-4 text-center text-xs md:text-sm font-bold text-white uppercase tracking-wider">
                      High-End Lighters
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {/* Price */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm font-semibold text-gray-900">
                      Price
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center bg-emerald-50">
                      <span className="text-sm md:text-lg font-bold text-emerald-600">$49.90</span>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center text-xs md:text-sm text-gray-600">
                      $2-3 each
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center text-xs md:text-sm text-gray-600">
                      $25-40
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center text-xs md:text-sm text-gray-600">
                      $100-300+
                    </td>
                  </tr>

                  {/* Rechargeable */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm font-semibold text-gray-900">
                      Rechargeable
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center bg-emerald-50">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm font-medium text-emerald-700">USB</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Disposable</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Needs fuel</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-alert-line text-lg md:text-2xl text-amber-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Some models</span>
                      </div>
                    </td>
                  </tr>

                  {/* Cigarette Case */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm font-semibold text-gray-900">
                      Cigarette Case
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center bg-emerald-50">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm font-medium text-emerald-700">Built-in</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">None</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">None</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Usually none</span>
                      </div>
                    </td>
                  </tr>

                  {/* Windproof */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm font-semibold text-gray-900">
                      Windproof
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center bg-emerald-50">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm font-medium text-emerald-700">Always</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Never</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-alert-line text-lg md:text-2xl text-amber-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Sometimes</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm text-gray-500">Usually</span>
                      </div>
                    </td>
                  </tr>

                  {/* Durability */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm font-semibold text-gray-900">
                      Durability
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center bg-emerald-50">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm font-medium text-emerald-700">Military-grade</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-close-line text-lg md:text-2xl text-red-500"></i>
                        <span className="text-xs md:text-sm text-gray-500">Breaks easily</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm text-gray-500">Good</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center gap-1 md:gap-2">
                        <i className="ri-check-line text-lg md:text-2xl text-emerald-600"></i>
                        <span className="text-xs md:text-sm text-gray-500">Good</span>
                      </div>
                    </td>
                  </tr>

                  {/* Cost Per Year */}
                  <tr className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-xs md:text-sm font-semibold text-gray-900">
                      Cost Per Year
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center bg-emerald-50">
                      <div className="flex flex-col items-center justify-center">
                        <span className="text-sm md:text-lg font-bold text-emerald-600">$49.90</span>
                        <span className="text-xs text-emerald-600">once</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex flex-col items-center justify-center">
                        <span className="text-sm md:text-base font-semibold text-red-600">$200+</span>
                        <span className="text-xs text-gray-500">ongoing</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex flex-col items-center justify-center">
                        <span className="text-sm md:text-base font-semibold text-gray-700">$60+</span>
                        <span className="text-xs text-gray-500">fuel costs</span>
                      </div>
                    </td>
                    <td className="px-3 md:px-6 py-3 md:py-4 whitespace-nowrap text-center">
                      <div className="flex flex-col items-center justify-center">
                        <span className="text-sm md:text-base font-semibold text-gray-700">$100-300+</span>
                        <span className="text-xs text-gray-500">upfront</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-8 md:mt-12">
          <p className="text-base md:text-xl font-semibold text-gray-900 mb-4 md:mb-6">
            The choice is clear. Get the best value and performance.
          </p>
          <a
            href="#offer"
            className="inline-block bg-gradient-to-r from-emerald-600 to-emerald-700 text-white px-6 md:px-10 py-3 md:py-4 rounded-full text-sm md:text-lg font-bold hover:from-emerald-700 hover:to-emerald-800 transition-all duration-300 shadow-lg hover:shadow-xl active:scale-95 whitespace-nowrap"
          >
            BUY NOW - $49.90
          </a>
        </div>
      </div>
    </section>
  );
};

export default DetailsSection;